module.exports = __webpack_public_path__ + "img/cowtribe_logo.4b9098e2.png";